var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "recharge-first",
      class: { "ar-style": _vm.$i18n.locale === "ar" },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.closeWeb },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow01.png"),
                        alt: "",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "recharge-content" }, [
        _vm.$i18n.locale === "ar"
          ? _c("img", {
              staticClass: "rec-fir-tit",
              attrs: { src: require("./images/title-ar.png"), alt: "" },
            })
          : _vm.$i18n.locale === "es"
          ? _c("img", {
              staticClass: "rec-fir-tit",
              attrs: { src: require("./images/title-es.png"), alt: "" },
            })
          : _vm.$i18n.locale === "pt"
          ? _c("img", {
              staticClass: "rec-fir-tit",
              attrs: { src: require("./images/title-pt.png"), alt: "" },
            })
          : _c("img", {
              staticClass: "rec-fir-tit",
              attrs: { src: require("./images/title-en.png"), alt: "" },
            }),
        _c("div", { staticClass: "rec-fir-date" }, [
          _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k083")) + " "),
          _c("img", { attrs: { src: require("./images/clock.png") } }),
          _vm._v(" " + _vm._s(_vm.showTime) + " "),
        ]),
        _c("div", { staticClass: "rec-fir-con" }, [
          _c("div", { staticClass: "rec-fir-block" }, [
            _c("div", { staticClass: "rec-fir-reward" }, [
              _c("div", { staticClass: "fir-reward-l" }, [
                _c("span", { staticClass: "fir-reward-tit" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k084"))),
                ]),
                _c("img", {
                  staticClass: "fir-reward-coin",
                  attrs: { src: _vm.getMatchImg("coin"), alt: "" },
                }),
                _vm.baseInfo
                  ? _c("span", { staticClass: "fir-reward-num" }, [
                      _vm._v(_vm._s(_vm.baseInfo.originAmount)),
                    ])
                  : _vm._e(),
                _vm.baseInfo
                  ? _c("span", { staticClass: "fir-reward-price" }, [
                      _vm._v(
                        _vm._s(_vm.baseInfo.currency) +
                          _vm._s(_vm.handleDiv100(_vm.baseInfo.originPrice))
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm.baseInfo && _vm.baseInfo.discountDesc === "40%"
                ? _c("img", {
                    staticClass: "fir-reward-c",
                    attrs: { src: require("./images/up-f.png") },
                  })
                : _vm._e(),
              _vm.baseInfo && _vm.baseInfo.discountDesc === "30%"
                ? _c("img", {
                    staticClass: "fir-reward-c",
                    attrs: { src: require("./images/up-t.png") },
                  })
                : _vm._e(),
              _c("div", { staticClass: "fir-reward-r" }, [
                _c("span", { staticClass: "fir-reward-tit" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k085"))),
                ]),
                _c("img", {
                  staticClass: "fir-reward-coin",
                  attrs: { src: _vm.getMatchImg("coins"), alt: "" },
                }),
                _vm.baseInfo
                  ? _c("span", { staticClass: "fir-reward-num" }, [
                      _vm._v(_vm._s(_vm.baseInfo.amount)),
                    ])
                  : _vm._e(),
                _vm.baseInfo
                  ? _c("span", { staticClass: "fir-reward-price" }, [
                      _vm._v(
                        _vm._s(_vm.baseInfo.currency) +
                          _vm._s(_vm.handleDiv100(_vm.baseInfo.price))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "rec-fir-deliver" }, [
              _vm._m(0),
              _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k086")) + " "),
              _vm._m(1),
            ]),
            _c("div", { staticClass: "rec-fir-fecture" }, [
              _c("div", { staticClass: "fir-fecture-item" }, [
                _c("img", {
                  attrs: { src: require("./images/video.png"), alt: "" },
                }),
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k087")))]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("lang.coupon.extra")) +
                        " x" +
                        _vm._s(_vm.matchPassExtra)
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "fir-fecture-item" }, [
                _c("img", {
                  attrs: { src: require("./images/message.png"), alt: "" },
                }),
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k088")))]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("lang.coupon.extra")) +
                        " x" +
                        _vm._s(_vm.superChatPassExtra)
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "rec-fir-btn",
          class: { "cannot-claim": !_vm.baseInfo || !_vm.baseInfo.ifValid },
          on: { click: _vm.handleClaim },
        },
        [_c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k089")))])]
      ),
      _c("ul", { staticClass: "rec-fir-tip" }, [
        _c(
          "li",
          [
            _c("MyPLabel", {
              attrs: {
                str: _vm.$t("lang.commonM.k090"),
                numsOption: [{ value: _vm.randowCount }],
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "deliver-l" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "deliver-r" }, [_c("div")])
  },
]
render._withStripped = true

export { render, staticRenderFns }